import imageManifest from './manifest-images.json';
import publicManifest from './manifest-public.json';
import { parse } from 'url';

const manifest = 'manifest-public.json';

interface OptionProps {
  width?: number;
  height?: number;
  fit?: string;
  fill?: string;
  mask?: string;
  dpr?: number;
}

export function manifestPath(): string {
  return `/${manifest}`;
  // if (process.env['NODE_ENV'] === 'development') {
  //   return `/static/${manifest}`;
  // }
  // const json: any = publicManifest;
  // const pathname = json[manifest];
  // const cdnHostname = process.env['JICOO_CDN_IMAGE_HOST'];
  // return `${cdnHostname}/static/${pathname}`;
}

export function imagePath(
  url: string,
  options: OptionProps | null = null,
): string {
  const json: any = imageManifest;
  let pathname = json[url] || url;
  if (pathname.indexOf('images.ctfassets.net') !== -1) {
    // SSRの時にparseの挙動が異なり、hostnameがparseされないので、
    // protocolを追加する
    pathname = `https:${pathname};`;
  }
  const cdnHostname = process.env['JICOO_CDN_IMAGE_HOST'];
  const parsedUrl = parse(pathname);
  if (!cdnHostname) {
    // storybook
    if (parsedUrl.hostname) {
      return url;
    } else {
      return `/static/images/${pathname}`;
    }
  }
  if (parsedUrl.hostname) {
    if (parsedUrl.hostname !== parse(cdnHostname).hostname) {
      return url;
    }
    return transformImageUrl(url, options) || '';
  } else {
    const fullUrl = `${cdnHostname}/static/images/${pathname}`;
    if (options) {
      return transformImageUrl(fullUrl, options) || '';
    }
    return fullUrl;
  }
}

export function transformCmsImageUrl(
  url: string | null,
  options: OptionProps | null = null,
): string | null {
  if (!url) return null;
  const cmsHost = String(process.env['API_CMS_HOST']);
  // const cmsCdnHost = String(process.env['API_CMS_CDN_HOST']);
  const cmsCdnHost = String(process.env['API_CMS_HOST']);
  const cdnUrl = url.replace(cmsHost, cmsCdnHost);
  const parsedUrl = parse(cdnUrl);
  if (options) {
    const searchParams = new URLSearchParams(parsedUrl.search || '');
    const newSearches = formatImageQuery(options);
    for (const kv of newSearches) {
      searchParams.set(kv[0], kv[1]);
    }
    let newUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}`;
    const search = searchParams.toString();
    if (search) {
      newUrl += `?${search}`;
    }
    return newUrl;
  }
  return cdnUrl;
}
export function transformContentfulImageUrl(
  url: string,
  options: OptionProps | null = null,
): string {
  const searchParams = new URLSearchParams();
  const queries: any = {
    fit: 'fill',
  };
  if (options) {
    const dpr = options.dpr ?? 1;
    if (options.width) queries['w'] = options.width * dpr;
    if (options.height) queries['h'] = options.height * dpr;
    if (options.fit) queries['fit'] = options.fit;
  }

  const newSearches: string[][] = [];
  Object.keys(queries).forEach((key) => {
    newSearches.push([key, queries[key]]);
  });
  for (const kv of newSearches) {
    searchParams.set(kv[0], kv[1]);
  }
  const search = searchParams.toString();
  if (search) {
    return url + `?${search}`;
  }
  return url;
}

export function transformImageUrl(
  url: string | null,
  options: OptionProps | null = null,
): string | null {
  if (!url) return null;
  const parsedUrl = parse(url);
  const cdnHostname = process.env['JICOO_CDN_IMAGE_HOST'];
  if (!cdnHostname) {
    return url;
  }
  if (parsedUrl.hostname !== parse(cdnHostname).hostname) {
    return url;
  }
  const searchParams = new URLSearchParams(parsedUrl.search || '');
  const newSearches = formatImageQuery(options);
  for (const kv of newSearches) {
    searchParams.set(kv[0], kv[1]);
  }
  let newUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}`;
  const search = searchParams.toString();
  if (search) {
    newUrl += `?${search}`;
  }
  return newUrl;
}

function formatImageQuery(options: OptionProps | null = null) {
  const queries: any = {
    auto: 'format',
    fit: 'fill',
    fill: 'solid',
  };
  if (options) {
    if (options.mask) queries['mask'] = options.mask;
    if (options.width) queries['w'] = options.width;
    if (options.height) queries['h'] = options.height;
    if (options.fit) queries['fit'] = options.fit;
    if (options.fill) queries['fill'] = options.fill;
    if (options.dpr) queries['dpr'] = options.dpr;
  }

  const newSearches: string[][] = [];
  Object.keys(queries).forEach((key) => {
    newSearches.push([key, queries[key]]);
  });
  return newSearches;
}
